var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"4.06066","y1":"1.93934","x2":"36.0607","y2":"33.9393","stroke":"white","strokeWidth":"3","key":0}),React.createElement("line",{"x1":"1.93934","y1":"33.9393","x2":"33.9393","y2":"1.93934","stroke":"white","strokeWidth":"3","key":1})]);
}

X.defaultProps = {"viewBox":"-10 -10 58 55","fill":"none"};

module.exports = X;

X.default = X;
